import { Question, QUESTION_TYPES } from '@commutifi-fe/interfaces'
import { ICustomQuestionProps } from 'shared/interfaces/Survey'
import { baseQuestion } from 'constants/surveys'

export const dropOffOrPickupKidsQuestion = (props: ICustomQuestionProps): Question => ({
  ...baseQuestion,
  type: QUESTION_TYPES.activityMapper,
  order: 1,
  ...props,
  content: {
    id: 'activity-mapper',
    questionId: props.id,
    locale: 'en-US',
    ...props.content
  }
})
